(function () {
  // Support Safari 11 and above
  function isSupportedSafariVersion(agentStr) {
    if (
      agentStr.indexOf('Safari') === -1 ||
      agentStr.indexOf('Version/') === -1
    ) {
      // Not Safari
      return true;
    } else if (
      agentStr.indexOf('iPad') !== -1 ||
      agentStr.indexOf('iPhone') !== -1
    ) {
      return true;
    } else {
      var start = agentStr.substring(agentStr.indexOf('Version/'));
      var version = parseFloat(start.substring(8, 11));
      return version >= 11.0;
    }
  }
  var isDigitalQuoteDomain =
    (window.location.hostname || '').indexOf('digital-quote.com') !== -1;

  if (isDigitalQuoteDomain) {
    return;
  }

  var userAgent = window.navigator.userAgent;
  var isOldBrowser =
    userAgent.indexOf('MSIE ') > 0 || // IE <11
    userAgent.indexOf('Trident/7.0') > 0 || // IE 11
    !isSupportedSafariVersion(userAgent) ||
    !('querySelector' in document) ||
    !('localStorage' in window) ||
    !('addEventListener' in window);
  if (isOldBrowser) {
    window.location.href = isDigitalQuoteDomain
      ? '/app/old_browser.digiquote.html'
      : '/app/old_browser.html';
  }
})();
